<template>
  <div class="outras-informacoes-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Informacoes')"
            :value="pet.informacoes | capitalize({ onlyFirstLetter: true })"
            :is-restrict="$store.getters['pet/isRestrict']('informacoes')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Outras_Informacoes") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Outras_Informacoes"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
  },
};
</script>

<style scoped></style>
